import { FC } from 'react';

import {
  LoginButton,
  LoginIcon,
  LoginMessage,
  LoginRequiredContainer,
  LoginTitle,
} from './OcLoginRequired.styled';

export interface OcLoginRequiredProps {
  loginUrl: string;
  title?: string;
  message?: string;
  buttonText?: string;
}

export const OcLoginRequired: FC<OcLoginRequiredProps> = ({
  loginUrl,
  title = 'Authentication Required',
  message = 'Please log in to use the AI Assistant',
  buttonText = 'Log In',
}) => {
  return (
    <LoginRequiredContainer>
      <LoginIcon
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
        <polyline points="10 17 15 12 10 7" />
        <line x1="15" y1="12" x2="3" y2="12" />
      </LoginIcon>
      <LoginTitle>{title}</LoginTitle>
      <LoginMessage>{message}</LoginMessage>
      <LoginButton href={loginUrl}>{buttonText}</LoginButton>
    </LoginRequiredContainer>
  );
};

